import React, {Component} from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { compose, withHandlers } from "recompose";
import Button from "react-md/lib/Buttons/Button";
import Checkbox from "../form/Checkbox";
import TextField from "../form/TextField";
import SelectField from "../form/SelectField";
import {DebugElement} from "../../Atollon/debug";
import {forEach, merge} from "lodash";
import * as Validation from "../form/Validation";
import { newRequestWithInputAsStruct } from "../../actions/requestActions";
import { getUser } from "../../actions/userActions";
import {TouchCheckbox} from "../../AtollonTheme/ReactElements";
import TranslationOld from "../../pages/RequestDetail/translation_old_cs.js";
import fetch from "../../utils/fetch";
import {getJSONOrNull} from "../../actions/OauthApplicationsActions";
import {getApiPrefix_lagoon, getMainTouchUrl} from "../../constants";

class TouchFieldError
{
    errors = [];
    clearErrors(){ this.errors = []; }
    setErrorToField(name, errorAsString ){ this.errors[name] = errorAsString; }
    getErrorForField(name){
        const error = this.errors[name] || false;
        console.log({error});
        return error;
    }
}

class TouchFieldValidate
{
        addValidatorForField( fieldName, fn )
        {
        }
}

let error = new TouchFieldError;
let validator = new TouchFieldValidate;

// /api/jersey/auth/companyIndustry

function TouchField( props )
{
        return <Field {...props} />;
}

class OrganizationNewForm extends Component
{
    countryCodes = {
            "AF" : "Afghanistan",
            "AX" : "Ĺland Islands",
            "AL" : "Albania",
            "DZ" : "Algeria",
            "AS" : "American Samoa",
            "AD" : "Andorra",
            "AO" : "Angola",
            "AI" : "Anguilla",
            "AQ" : "Antarctica",
            "AG" : "Antigua and Barbuda",
            "AR" : "Argentina",
            "AM" : "Armenia",
            "AW" : "Aruba",
            "AU" : "Australia",
            "AT" : "Austria",
            "AZ" : "Azerbaijan",
            "BS" : "Bahamas",
            "BH" : "Bahrain",
            "BD" : "Bangladesh",
            "BB" : "Barbados",
            "BY" : "Belarus",
            "BE" : "Belgium",
            "BZ" : "Belize",
            "BJ" : "Benin",
            "BM" : "Bermuda",
            "BT" : "Bhutan",
            "BO" : "Bolivia",
            "BA" : "Bosnia and Herzegovina",
            "BW" : "Botswana",
            "BV" : "Bouvet Island",
            "BR" : "Brazil",
            "IO" : "British Indian Ocean Territory",
            "BN" : "Brunei Darussalam",
            "BG" : "Bulgaria",
            "BF" : "Burkina Faso",
            "BI" : "Burundi",
            "KH" : "Cambodia",
            "CM" : "Cameroon",
            "CA" : "Canada",
            "CV" : "Cape Verde",
            "KY" : "Cayman Islands",
            "CF" : "Central African Republic",
            "TD" : "Chad",
            "CL" : "Chile",
            "CN" : "China",
            "CX" : "Christmas Island",
            "CC" : "Cocos (Keeling) Islands",
            "CO" : "Colombia",
            "KM" : "Comoros",
            "CG" : "Congo",
            "CD" : "Congo, The Democratic Republic of The",
            "CK" : "Cook Islands",
            "CR" : "Costa Rica",
            "CI" : "Cote D'ivoire",
            "HR" : "Croatia",
            "CU" : "Cuba",
            "CY" : "Cyprus",
            "CZ" : "Czech Republic",
            "DK" : "Denmark",
            "DJ" : "Djibouti",
            "DM" : "Dominica",
            "DO" : "Dominican Republic",
            "EC" : "Ecuador",
            "EG" : "Egypt",
            "SV" : "El Salvador",
            "GQ" : "Equatorial Guinea",
            "ER" : "Eritrea",
            "EE" : "Estonia",
            "ET" : "Ethiopia",
            "FK" : "Falkland Islands (Malvinas)",
            "FO" : "Faroe Islands",
            "FJ" : "Fiji",
            "FI" : "Finland",
            "FR" : "France",
            "GF" : "French Guiana",
            "PF" : "French Polynesia",
            "TF" : "French Southern Territories",
            "GA" : "Gabon",
            "GM" : "Gambia",
            "GE" : "Georgia",
            "DE" : "Germany",
            "GH" : "Ghana",
            "GI" : "Gibraltar",
            "GR" : "Greece",
            "GL" : "Greenland",
            "GD" : "Grenada",
            "GP" : "Guadeloupe",
            "GU" : "Guam",
            "GT" : "Guatemala",
            "GG" : "Guernsey",
            "GN" : "Guinea",
            "GW" : "Guinea-bissau",
            "GY" : "Guyana",
            "HT" : "Haiti",
            "HM" : "Heard Island and Mcdonald Islands",
            "VA" : "Holy See (Vatican City State)",
            "HN" : "Honduras",
            "HK" : "Hong Kong",
            "HU" : "Hungary",
            "IS" : "Iceland",
            "IN" : "India",
            "ID" : "Indonesia",
            "IR" : "Iran, Islamic Republic of",
            "IQ" : "Iraq",
            "IE" : "Ireland",
            "IM" : "Isle of Man",
            "IL" : "Israel",
            "IT" : "Italy",
            "JM" : "Jamaica",
            "JP" : "Japan",
            "JE" : "Jersey",
            "JO" : "Jordan",
            "KZ" : "Kazakhstan",
            "KE" : "Kenya",
            "KI" : "Kiribati",
            "KP" : "Korea, Democratic People's Republic of",
            "KR" : "Korea, Republic of",
            "KW" : "Kuwait",
            "KG" : "Kyrgyzstan",
            "LA" : "Lao People's Democratic Republic",
            "LV" : "Latvia",
            "LB" : "Lebanon",
            "LS" : "Lesotho",
            "LR" : "Liberia",
            "LY" : "Libyan Arab Jamahiriya",
            "LI" : "Liechtenstein",
            "LT" : "Lithuania",
            "LU" : "Luxembourg",
            "MO" : "Macao",
            "MK" : "Macedonia, The Former Yugoslav Republic of",
            "MG" : "Madagascar",
            "MW" : "Malawi",
            "MY" : "Malaysia",
            "MV" : "Maldives",
            "ML" : "Mali",
            "MT" : "Malta",
            "MH" : "Marshall Islands",
            "MQ" : "Martinique",
            "MR" : "Mauritania",
            "MU" : "Mauritius",
            "YT" : "Mayotte",
            "MX" : "Mexico",
            "FM" : "Micronesia, Federated States of",
            "MD" : "Moldova, Republic of",
            "MC" : "Monaco",
            "MN" : "Mongolia",
            "ME" : "Montenegro",
            "MS" : "Montserrat",
            "MA" : "Morocco",
            "MZ" : "Mozambique",
            "MM" : "Myanmar",
            "NA" : "Namibia",
            "NR" : "Nauru",
            "NP" : "Nepal",
            "NL" : "Netherlands",
            "AN" : "Netherlands Antilles",
            "NC" : "New Caledonia",
            "NZ" : "New Zealand",
            "NI" : "Nicaragua",
            "NE" : "Niger",
            "NG" : "Nigeria",
            "NU" : "Niue",
            "NF" : "Norfolk Island",
            "MP" : "Northern Mariana Islands",
            "NO" : "Norway",
            "OM" : "Oman",
            "PK" : "Pakistan",
            "PW" : "Palau",
            "PS" : "Palestinian Territory, Occupied",
            "PA" : "Panama",
            "PG" : "Papua New Guinea",
            "PY" : "Paraguay",
            "PE" : "Peru",
            "PH" : "Philippines",
            "PN" : "Pitcairn",
            "PL" : "Poland",
            "PT" : "Portugal",
            "PR" : "Puerto Rico",
            "QA" : "Qatar",
            "RE" : "Reunion",
            "RO" : "Romania",
            "RU" : "Russian Federation",
            "RW" : "Rwanda",
            "SH" : "Saint Helena",
            "KN" : "Saint Kitts and Nevis",
            "LC" : "Saint Lucia",
            "PM" : "Saint Pierre and Miquelon",
            "VC" : "Saint Vincent and The Grenadines",
            "WS" : "Samoa",
            "SM" : "San Marino",
            "ST" : "Sao Tome and Principe",
            "SA" : "Saudi Arabia",
            "SN" : "Senegal",
            "RS" : "Serbia",
            "SC" : "Seychelles",
            "SL" : "Sierra Leone",
            "SG" : "Singapore",
            "SK" : "Slovakia",
            "SI" : "Slovenia",
            "SB" : "Solomon Islands",
            "SO" : "Somalia",
            "ZA" : "South Africa",
            "GS" : "South Georgia and The South Sandwich Islands",
            "ES" : "Spain",
            "LK" : "Sri Lanka",
            "SD" : "Sudan",
            "SR" : "Suriname",
            "SJ" : "Svalbard and Jan Mayen",
            "SZ" : "Swaziland",
            "SE" : "Sweden",
            "CH" : "Switzerland",
            "SY" : "Syrian Arab Republic",
            "TW" : "Taiwan, Province of China",
            "TJ" : "Tajikistan",
            "TZ" : "Tanzania, United Republic of",
            "TH" : "Thailand",
            "TL" : "Timor-leste",
            "TG" : "Togo",
            "TK" : "Tokelau",
            "TO" : "Tonga",
            "TT" : "Trinidad and Tobago",
            "TN" : "Tunisia",
            "TR" : "Turkey",
            "TM" : "Turkmenistan",
            "TC" : "Turks and Caicos Islands",
            "TV" : "Tuvalu",
            "UG" : "Uganda",
            "UA" : "Ukraine",
            "AE" : "United Arab Emirates",
            "GB" : "United Kingdom",
            "US" : "United States",
            "UM" : "United States Minor Outlying Islands",
            "UY" : "Uruguay",
            "UZ" : "Uzbekistan",
            "VU" : "Vanuatu",
            "VE" : "Venezuela",
            "VN" : "Viet Nam",
            "VG" : "Virgin Islands, British",
            "VI" : "Virgin Islands, U.S.",
            "WF" : "Wallis and Futuna",
            "EH" : "Western Sahara",
            "YE" : "Yemen",
            "ZM" : "Zambia",
            "ZW" : "Zimbabwe"
    };

    // onBlur
    // onChange
    // onFocus
    // onDragStart
    // onDrop
    // onBlur


    constructor( props ){
        super( props );
        this.state = { companyIndustryData: [], skipEmail: true };
    }

    componentWillReceiveProps() {}

    async componentWillMount()
    {
        let { getUser } = this.props;
        console.log('form mount',this);
        await getUser();

        let companyIndustryData = await getJSONOrNull({ url: `${getApiPrefix_lagoon()}/auth/companyIndustry`, doNotAlertErrors: false });
        this.setState({ companyIndustryData });
    }

    componentWillUnmount()
    {
    }

    async onSubmit( form, y, props )
    {
        // atollon.RequestUtils.getResourceName
        const getResourceName = function (ident, name)
        {
            if (ident.identifier)
            {
                if (ident.type == "PROJECT") {
                    ident = ident.name ? ident.name :
                        (ident.localName ? ident.localIdentifier : ident.idnetifier);
                } else {
                    name = ident.name;
                    ident = ident.identifier;
                }
            }
            var result = ident;
            if (name && name != ident)
                result = name + " ("+ident+")";
            return result;
        };
        const { newRequestWithInputAsStruct } = props;
        const sender = getResourceName( props.state.app.user ); //props.state.user.identifier;
        const { history } = props;
        console.log('form onsbumit',{ sender });
        let data =
            {
                subject: TranslationOld.getTranslationForKey('newOrganization.requestSubject'),
                messageBody: TranslationOld.getTranslationForKey('newOrganization.requestBody',
                    {organization: form.hostName, // newOrganization.hostName,
                        sender: getResourceName( props.state.app.user ) // atollon.RequestUtils.getResourceName(newOrganization.sender)}),
                    }),
                companyName: form.companyName, // $(".organizationName .value", infoForm).val(),
                address1: form.address1, //$(".address1 .value", infoForm).val(),
                address2: form.address2, // $(".address2 .value", infoForm).val(),
                region: form.city, // $(".city .value", infoForm).val(),
                countryCode: form.countryCode,// $(".country .value option:selected", infoForm).val(),
                formIdentifier: "com.atollon.form.register",
                language: 'cs', // $.i18n.lng(),
                recipients: [
                    {
                        identifier: 'admin', // atollon.Config.centralInstanceUser
                    }
                ],
                customFields: [
                    {
                        name: "city",
                        value: form.city, // $(".city .value", infoForm).val()
                    },
                    {
                        name: "hostName",
                        value: form.hostName,
                    },
                    {
                        name: "hostEmail",
                        value: form.hostEmail, // newOrganization.emailName
                    },
                    {
                        name: "industry",
                        value: form.industry, // $(".industry .value", infoForm).val()
                    },
                    {
                        name: "webAddress",
                        value: form.webAddress, // $(".website .value", infoForm).val()
                    },
                    {
                        name: "twitter",
                        value: form.twitter, // $(".twitter .value", infoForm).val()
                    },
                    {
                        name: "zipCode",
                        value: form.zipCode,// $(".zip .value", infoForm).val()
                    }
                ],
                sender: props.state.app.user.identifier, // newOrganization.sender.identifier,
                pendingSide: "RECIPIENT",
                status: "INITIAL",
                type: "CREATE_PROVIDER"
            };

        console.log('form', {data});
        debugger;

        const response = await newRequestWithInputAsStruct( data );
        if (response)
        {
            history.push(`/requests/${response.hash}`);
        }
        else
        {
            alert("Požadavek se nepodařilo vytvořit.");
        }

    }

    render() {
                let { handleSubmit } = this.props;
                let industryItems = [];
                if( this.state.companyIndustryData )
                {
                    forEach( this.state.companyIndustryData.item, item => {
                        industryItems.push({ label: item.name, value: item.id });
                    });
                }
                let countryCodes = [];
                forEach( this.countryCodes, ( countryName, countryIsoCode ) => {
                        countryCodes.push({ label: countryName, value: countryIsoCode });
                });

                console.log({ 'form props':  this.props });
                console.log({ 'form state':  this.state });
                // error.setErrorToField( 'email', 'Chyba!' );
                // error.setErrorToField( 'name', 'Chyba 2!' );

                return (
                        <form onSubmit={handleSubmit( this.onSubmit )} className="form">
                            <DebugElement text={"src/components/organizationNew/OrganizationNewForm.js"}/>
                            <div className="url" style={{justifyContent: 'left'}}>
                                <p>{getMainTouchUrl()}</p>
                                <TouchField component={TextField} label="Doména" name="hostName"  validate={[Validation.required]}
                                onChange={( a, hostName, c ) =>
                                {
                                    // if my email is from the same domain as host name then we
                                    // skip authorization
                                    //const loggedUserName = this.props.state
                                    const loggedUserName = this.props.state.app.user.identifier
                                    const matches = loggedUserName.match(/^([A-Z0-9_\.\-]+)@([A-Z0-9\.\-]+\.[A-Z]{2,4})$/i); // var matches = application.loggedUser.name.match(atollon.Validation.emailPattern);
                                    const skipEmail = matches && hostName.toLowerCase() === matches[2].toLowerCase(); // newOrganization.skipEmail = (matches && newOrganization.hostName.toLowerCase()
                                    //     == matches[2].toLowerCase());
                                    // if (newOrganization.skipEmail) {
                                    this.setState({ skipEmail });
                                    // }
                                }}/>
                            </div>
                            { !this.state.skipEmail ?
                                <TouchField component={TextField} label="Email" name="hostEmail" validate={[Validation.required, Validation.email]} />
                                : null
                            }
                            <TouchField component={TextField} label="Název organizace" name="companyName"  validate={[Validation.required]} />
                            <TouchField component={TextField} label="Adresa" name="address1" validate={[Validation.required]} />
                            <TouchField component={TextField} label="Adresa 2" name="address2"/>
                            <TouchField component={TextField} label="Město" name="city" validate={[Validation.required]} />
                            <TouchField component={TextField} label="PSČ" name="zipCode" validate={[Validation.required]} />
                            <TouchField
                                component={SelectField}
                                name="industry"
                                label="Odvětví společnosti"
                                menuItems={industryItems}
                                validate={[Validation.required]}
                            />
                            <TouchField
                                component={SelectField}
                                name="countryCode"
                                label="Země"
                                menuItems={countryCodes}
                                validate={[Validation.required]}
                            />
                            <div className="url" style={{justifyContent: 'left'}}>
                                <p>http://</p>
                                <TouchField component={TextField} label="Web" name="webAddress"/>
                            </div>
                            <div className="url" style={{justifyContent: 'left'}}>
                                <p>twitter.com/</p>
                                <TouchField component={TextField} label="Twitter" name="twitter"/>
                            </div>
                            <div className="touchCheckbox-inReduxField">
                                <TouchField
                                    component={Checkbox}
                                    className=""
                                    id="iAgree"
                                    name="iAgree"
                                    text="Potvrzuji, že jsem oprávněn jednat za výše uvedenou organizaci a souhlasím s podmínkami provozu."
                                    onChange={()=>{}}
                                    changeValue={()=>{}}
                                    validate={[Validation.required]}
                                />
                            </div>
                            {/*
                            <TouchField
                                component={TouchCheckbox}
                                id="iAgree"
                                name="iAgree"
                                label="Potvrzuji, že jsem oprávněn jednat za výše uvedenou organizaci a souhlasím s podmínkami provozu."
                                onChange={()=>{}}
                            />
                            */}
                            <div className="flex-row flex-right">
                                <Button
                                    flat
                                    primary
                                    label="Odeslat"
                                    type="submit"
                                    className="btn btn-primary touchButton-6"
                                />
                            </div>
                        </form>
                );
        }
}

export default connect(
            state => { return { state }} ,
            {
                newRequestWithInputAsStruct,
                getUser
            }
    )(
            reduxForm({
                form: 'OrganizationNewFormForm'
            })(OrganizationNewForm)
);



// WEBPACK FOOTER //
// ./src/components/organizationNew/OrganizationNewForm.js